import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import type { NoopT } from 'declarations/types/common';

import useTicketReopenPopup from './hooks/useTicketReopenPopup';
import { getPopupContentStyle } from './TicketReopenPopup.styled';

type TicketReopenPopupPropsT = {
  ticketId: string;
  isOpen: boolean;
  onClose: NoopT;
};

const TicketReopenPopup: FC<TicketReopenPopupPropsT> = ({ ticketId, isOpen, onClose }) => {
  const { isMobile } = useResponsive();
  const { isReopeningTicket, handleReopenTicket, handleClosePopup } = useTicketReopenPopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      popupId={ScrollLockIdE.TicketReopenPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      <Typography variant="h6" color="text.primary" align={isMobile ? 'center' : 'left'}>
        Are you sure you want to reopen the ticket?
      </Typography>
      <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} sx={{ mt: 2 }} gap={1}>
        <Button variant="outlined" onClick={handleClosePopup(onClose)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isReopeningTicket}
          onClick={handleReopenTicket([ticketId], onClose)}
        >
          {isReopeningTicket ? 'Reopening...' : 'Reopen'}
        </Button>
      </Box>
    </Popup>
  );
};

export default TicketReopenPopup;
